window.__assetPrefix__ = 'https://fe-static-test.hkgai.org/meeting-ai-fe-web/17069';